export default __webpack_public_path__ + "static/media/icon-hamburger.b0d311fe.svg";